<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Name</label>
                  <input type="text"  v-model="form.categoryname"/>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Code</label>
                  <input type="text" v-model="form.categorycode"/>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" v-model="form.description"></textarea>
                </div>
              </div>
              
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="categorylist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        categoryname: '',
        categorycode: '',
        description: '',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Item Edit Category",
      title1: "Edit a Item Category",
    };
  },
  methods: {
    postData() {
      if (!this.form.categoryname) {
        Swal.fire("Please enter the category name");
        return;
      }
      axios
      .put('/v1/category/' + this.id, this.form)
      .then(response => {
        Swal.fire("Category updated successfully");
        this.$router.push({ path: '/categorylist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getCategoryById(id) {
      axios
      .get('/v1/category/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getCategoryById(this.id);
  },
  name: "editcategory",
};
</script>
